export default __webpack_public_path__ + "static/media/2.3ec0360f.mp4";